module.exports = __webpack_public_path__ + "media/video_curto.f2c70018.mp4";